import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { LoadingService } from "../../../../services/loading.service";
import { MatTableDataSource } from "@angular/material/table";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { AventuraService } from "../../../../services/api/aventura.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogTrekkingComponent } from "./dialog-trekking/dialog-trekking.component";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: 'app-trekking',
  templateUrl: './trekking.component.html',
  styleUrls: ['./trekking.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TrekkingComponent implements OnInit {

  loader: boolean = false;

  listFileProduct: any = [];

  files: any = [];

  modelExpand: any;

  dataSource: any;

  displayedColumns: string[] = ['file', 'agencia','pax', 'ruta', 'fechaInicio', 'edit'];
  displayedColumns2: string[] = ['file', 'categoria','subCategoriaProducto','ruta', 'edit'];
  columnsToDisplayWithExpand = [...this.displayedColumns2, 'expand'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  //@ViewChild(MatSort) sort!: MatSort;


  constructor(private changeDetectorRefs: ChangeDetectorRef, public dialog: MatDialog, public loadingService: LoadingService, private aventuraService: AventuraService,) { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();

    this.getAllFileProducts();

  }

  getAllFileProducts() {
    this.aventuraService.getAllFiles().subscribe(async response => {

      this.listFileProduct = [];
      this.files = response.getAllFiles;

      console.log(this.files)

      for (let el of this.files) {
        await this.setDetailFile(el)
      }


      setTimeout(() => {
        this.loader = true;
      }, 5000);

    })

  }

  setDetailFile(file: any) {

    let itinerariesProducts: any[] = []

    file.itinerarios.map((itinerary: { services: { productId: any; }[]; }) => {
      const unique = [...new Set(itinerary.services.map((service: { productId: any; }) =>
        service.productId
      ))]

      unique.map(producto => {
        itinerariesProducts.push(producto)
      })

    })

    const uniqueByFile = [...new Set(itinerariesProducts.map(el => el))]
    console.log(uniqueByFile)

    //map por producto del file
    uniqueByFile.map(producto => {
      console.log(producto)

      if (producto) {
        this.getProductById(producto, file);
      }



    });

  }

  getProductById(id: String, file: any): void {
    //console.log("getProduct")
    this.aventuraService.getProductById(id).subscribe((response: any) => {
      let product = response.getProductById;
      if (product) {
        if (product.subCategoriaProducto === "TREKKING") {

          const fileProduct = {
            fileId: file.id,
            file: file.fileNumber,
            fileProductId: id,
            pax: file.paxQuantity,
            ruta: product.nombre,
            services: [],
            categoria: product.categoriaProducto,
            subCategoriaProducto:product.subCategoriaProducto

          }

          console.log(fileProduct)

          let pcServices: any = [];

          file.itinerarios.map((itinerary: { services: { productId: String; }[]; }, index: any) => {
            itinerary.services.map((service: { productId: String; }) => {
              if (service.productId === id) {

                this.getDetailService(service.productId, file, service, fileProduct, pcServices, index);

              }
            })
          })

          this.listFileProduct.push(fileProduct);
          this.dataSource.data = this.listFileProduct;

          this.dataSource.paginator = this.paginator
          console.log(this.dataSource.data)

        }
      }


    })

  }

  getDetailService(id: String, file: any, servicio: any, fileProduct: any, pcServices: any, itineraryIndex: any): void {

    if (servicio.tipoServicio == "PERSONALDECAMPO" || servicio.tipoServicio == "GUIA") {
      //console.log(servicio)
      this.aventuraService.getServiceById(servicio.serviceId).subscribe(response => {
        //console.log(response)
        this.aventuraService.getProvider(servicio.providerId).subscribe(res => {
          const service = {
            // id:servicio.id,//?
            idProducto: servicio.productId,//--
            idProveedor: servicio.providerId,//
            idServicio: servicio.serviceId,//
            idTarifa: servicio.tarifaId,//
            // isArchived:servicio.isArchived,//?
            isDeleted: servicio.isDeleted,
            //itineraryID:servicio.itineraryID,//--
            nombreServicio: servicio.nombreServicio,//
            //tipoProveedor:servicio.tipoProveedor,//
            tipoServicio: servicio.tipoServicio,//
            categoriaServicio: response.getServiceById.categoriaServicio,
            nombre: res.getProvider.nombre,
            itineraryIndex: itineraryIndex
          }

          fileProduct.services.push(service);
        })

      })
    }

  }

  openDialogEdit(id: any, productId: any): void {

    let i = 0;


    console.log(id)
    this.listFileProduct.map((el: { fileId: any; fileProductId: any }, index: any) => {
      if (el.fileId == id && el.fileProductId == productId) {
        i = index;
      }
    })
    console.log(i)

    console.log(this.listFileProduct[i]);

    let dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false, dialogConfig.maxHeight = '90vh'

    console.log(this.listFileProduct[i])

    dialogConfig.data = {
      file: this.listFileProduct[i],
      estado: 2,
    }

    dialogConfig.width = "50%";

    let dialogRef = this.dialog.open(DialogTrekkingComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log("closed");
      console.log(result)
      if (result == 1) {
        this.getAllFileProducts();
      }

    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.data.forEach((element: { [x: string]: string; }) => {
      for (const key in element) {
        if (!element[key] || element[key] === null) {
          element[key] = '';
        }
      }
    });

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
